




import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Handsontable, { DefaultSettings } from "handsontable";
import "handsontable/dist/handsontable.css";

interface SwxTable {
    instance: Handsontable;
}

@Component({
    name: "SwxTable"
})
class SwxTable extends Vue {
    @Prop({ type: Object, required: true })
    public settings!: DefaultSettings;

    @Watch("settings.data")
    updateData(data) {
        this.loadData(data);
    }

    destroy() {
        this.instance.destroy();
    }

    loadData(data): void {
        this.instance.loadData(data);
    }

    mounted() {
        this.instance = new Handsontable(this.$el, this.settings);
    }

    beforeDestroy() {
        this.destroy();
    }
}

export default SwxTable;
